import { Action } from "@ngrx/store";
import { Update } from "@ngrx/entity";
import { MediaModel } from "../models";

export enum MediaActionTypes {
	MediasOfTreatmentRequested = "[Media] Medias of Treatment Requested",
	MediasOfTicketRequested = "[Media] Medias of Ticket Requested",
	LoadMedias = "[Media] Load Medias",
	AddMedia = "[Media] Add Media",
	UpdateMedia = "[Media] Update Media",
	DeleteMedia = "[Media] Delete Media",
	DeleteMediaFromStore = "[Media] Delete Media From Store",
	ClearMedias = "[Media] Clear Medias",
	AddFileInUpload = "[Media] Add Currently Uploading File",
	RemoveFileInUpload = "[Media] Remove Currently Uploading File",
}
export class MediasOfTreatmentRequested implements Action {
	readonly type = MediaActionTypes.MediasOfTreatmentRequested;
	constructor(public payload: { treatmentId: string; fetchFromAssociatedTreatments: boolean }) {}
}

export class MediasOfTicketRequested implements Action {
	readonly type = MediaActionTypes.MediasOfTicketRequested;
	constructor(public payload: { ticketId: string }) {}
}

export class LoadMedias implements Action {
	readonly type = MediaActionTypes.LoadMedias;

	constructor(public payload: { medias: MediaModel[] }) {}
}

export class AddMedia implements Action {
	readonly type = MediaActionTypes.AddMedia;

	constructor(public payload: { media: MediaModel }) {}
}

export class UpdateMedia implements Action {
	readonly type = MediaActionTypes.UpdateMedia;

	constructor(public payload: { media: Update<MediaModel> }) {}
}

export class DeleteMedia implements Action {
	readonly type = MediaActionTypes.DeleteMedia;

	constructor(public payload: { id: string; treatmentId?: string }) {}
}

export class DeleteMediaFromStore implements Action {
	readonly type = MediaActionTypes.DeleteMediaFromStore;
	constructor(public payload: { id: string }) {}
}

export class ClearMedias implements Action {
	readonly type = MediaActionTypes.ClearMedias;
}

export class AddFileInUploadAction implements Action {
	readonly type = MediaActionTypes.AddFileInUpload;
	constructor(public payload: { filename: string }) {}
}

export class RemoveFileInUploadAction implements Action {
	readonly type = MediaActionTypes.RemoveFileInUpload;
	constructor(public payload: { filename: string }) {}
}

export type MediaActions =
	| MediasOfTreatmentRequested
	| MediasOfTicketRequested
	| LoadMedias
	| AddMedia
	| UpdateMedia
	| DeleteMedia
	| DeleteMediaFromStore
	| ClearMedias
	| AddFileInUploadAction
	| RemoveFileInUploadAction;
